import { defineMessages } from 'react-intl';

const translations = {
  cancelButton: {
    id: 'filterSelection.filterSelectionItem.cancelButton',
    defaultMessage: 'Cancel',
    description: 'The label of the cancel filter selection button',
  },
  saveButton: {
    id: 'filterSelection.filterSelectionItem.saveButton',
    defaultMessage: 'Save',
    description: 'The label of the save filter selection button',
  },
  createButton: {
    id: 'filterSelection.filterSelectionItem.createButton',
    defaultMessage: 'Create',
    description: 'The label of the create filter selection button',
  },
  newFilterHeader: {
    id: 'filterSelection.filterSelectionItem.newFilterHeader',
    defaultMessage: 'Create filter',
    description: 'The header title of the create filter selection',
  },
};

export default defineMessages(translations);
